export default "__VITE_ASSET__3HaVDFT$__"